export const SUMMON_PORTAL_ELEMENT_CIRCLES: Readonly<Record<string, string>> = Object.freeze({
  fire: 'FabPortalFireCircleTop', fiend: 'FabPortalFireCircleTop', dragon: 'FabPortalFireCircleTop',
  undead: 'FabPortalDarkCircleTop', aberration: 'FabPortalDarkCircleTop',
  celestial: 'FabPortalLightCircleTop',
  ice: 'FabPortalIceCircleTop',
  earth: 'FabPortalEarthCircleTop', giant: 'FabPortalEarthCircleTop', plant: 'FabPortalEarthCircleTop', beast: 'FabPortalEarthCircleTop',
  storm: 'FabPortalStormCircleTop',
});
export const ELEMENT_CIRCLE_SPLIT: Readonly<Record<string, {rune: readonly string[]; rise: readonly string[]}>> = Object.freeze({
  FabPortalFireCircleTop: {rune: ['FabPortalFireCircleRune2', 'FabPortalFireCircleRune'], rise: ['FabPortalFireCircleRise2', 'FabPortalFireCircleRise']},
  FabPortalEarthCircleTop: {rune: ['FabPortalEarthCircleRune2', 'FabPortalEarthCircleRune'], rise: ['FabPortalEarthCircleRise']},
  FabPortalIceCircleTop: {rune: ['FabPortalIceCircleRune2', 'FabPortalIceCircleRune'], rise: ['FabPortalIceCircleRise']},
  FabPortalDarkCircleTop: {rune: ['FabPortalDarkCircleRune2', 'FabPortalDarkCircleRune'], rise: ['FabPortalDarkCircleRise']},
  FabPortalLightCircleTop: {rune: ['FabPortalLightCircleRune2', 'FabPortalLightCircleRune'], rise: ['FabPortalLightCircleRise']},
  FabPortalStormCircleTop: {rune: [], rise: ['FabPortalStormCircleRise']},
});
export const GROUND_CIRCLE_TEXTURES: ReadonlySet<string> = new Set(Object.values(SUMMON_PORTAL_ELEMENT_CIRCLES));
